module.exports = __webpack_public_path__ + "img/MM.ef6a8119.svg";